import Component from './ViewDefaultPopupFormForget.vue';
export default Component;



// WEBPACK FOOTER //
// ./src/pages/default/popup/forms/forget/index.js